<template>
  <div>
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content"
        v-loading="loadingStaus"
        :element-loading-text="loadingText">
        <el-row :gutter="48">
          <el-form ref="companyForm" :model="formData" :rules="rules" label-width="100px">
            <el-col :span="18">
              <el-form-item v-for="(item,index) in formList" :key="index" :label="item.label" :prop="item.props">
                <el-input v-if="item.type=='select'" disabled :value="item.propsData[formData[item.props]]"></el-input>
                <el-input v-else disabled :value="formData[item.props]"></el-input>
              </el-form-item>
              <el-form-item label="税源地名称" prop="channel_name">
                <el-input disabled :value="formData.channel_name"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
         <!-- 预览图片弹框 -->
        <el-dialog
          :title="'预览图片'"
          :visible.sync="dialogVisible"
          :modal="false"
          :width="'35%'"
        >
          <div class="block" v-if="dialogVisible">
            <img :src="this.imageUrl" class="preview">
          </div>
        </el-dialog>
      </div>
    </PageHeaderLayout>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import UploadFile from "@/components/UploadFile";
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    UploadFile,
  },
  data() {
    return {
      formList: [
      {
          title: "姓名",
          value: "bank_account_name"
        },
        {
          title: "身份证号码",
          value: "id_number",
        },
        {
          title: "手机号码",
          value: "mobile",
        },
        {
          title: "收款账号",
          value: "bank_account_no"
        },
        {
          title: "结算金额",
          value: "money",
        },
        {
          title: "实收金额",
          value: "after_money",
        },
        {
          title: "个税",
          value: "now_tax_money",
        },
        {
          title: "银行名称",
          value: "bank_name",
        },
        {
          title: "开户行名称",
          value: "bank_branch"
        },
        {
          title: "编码",
          value: "code",
        },
        {
          title: "下发通道",
          value: "send_type",
        },
        {
          title: "上传时间",
          value: "created_at",
        },
      ],
      dialogVisible: false,
      activeTab: '0',
      hearTitle: '基本设置',
      loadingStaus: true,
      loadingText: '正在提交中……',
      formDisabled: false,
      billId:0, // 公司id，0表示创建，非零为编辑
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      // 分类列表
      categoryList:[],
      openapiList:[],
      // 标签
      categoryLabelList:[],
      // 已选中的分类列表，用于cascader组件选中效果
      selectedList:[],
      // 已选中标签
      selectedLabelList:[],
      // 公司基本信息表单结构
      formData:{},
      // 已上传图片列表
      uploadFileList:[],
      // 公司基本信息规则
      rules: {
        name: [
          {required: true, message: '输入公司名称', trigger: 'blur' },
        ],
        file_url: [
          {required: true, message: '输入文件名称', trigger: 'blur' },
        ]
      },
      // 附件类型
      attachmentType:['application/pdf','application/caj','','application/zip','application/rar','application/doc'],
      // 已上传附件列表
      attachmentUploadFileList:[],
      imageUrl: '',//图片地址
    }
  },
  computed: {
    ...mapGetters(['userPermissions']),
  },
  methods: {
    /* 预览图片 */
    showImage(data) {
      this.dialogVisible = true;
      this.imageUrl = data;
    },
    // 初始化公司基本信息
    async init() {
      let url = this.$route.path
      let urlSlashCount=url.split('/').length
      this.action = url.split('/')[urlSlashCount-1].toLowerCase()
      this.formDisabled = (this.action === 'view') ? true : false
      console.log("action -> ", this.formDisabled)
      if (this.$route.params.customer_id) {
        this.id = this.$route.params.customer_id
      }
      if (this.id) {
        let {info} = await this.$api.getCustomerInfo(this.id)
        console.log("formData", info)
        this.formData = info
      }
    },
    //返回上一页
    goBack() {
      this.$router.push({ path: "/mission_center" });
    }
  },
	async mounted() {
		this.formData = this.$route.params;
		this.formData.recruit_type_id = [this.formData.recruit_type_id];
    
		this.loadingStaus = true
		this.init()
		this.$nextTick(() => {
			this.loadingStaus = false
		})
	},
}
</script>

<style lang="stylus" scoped>
  .content-left
    min-height 640px
    border-right 1px solid  #e8e8e8
    .el-cascader
      display block
      width 320px
  .back-btn
    position absolute;
    right 50px;
    top 150px;
  .content-right
    .right-button
      border-top 1px solid #e8e8e8e8
      padding 12px 12px
    .el-form-item__label
      float none
      display inline-block
      text-align left
      padding 0 0 10px 0
    .el-form-item__content
      margin-left 0px !important
      .el-checkbox-group
        margin-top -12px
  .preview
    width: 100%
  .idImg
    width: 100px
    cursor: pointer
	
.QR-code {
  width: 250px;
  height: 250px;
}
</style>
